/** @format */

import { ActionCreatorWithPayload, createAction } from "@reduxjs/toolkit";
import { IPerson } from "lobbie";

export const setUser = createAction<(IPerson & { roleGroupIds?: string }) | undefined>(
    "user/set",
) as ActionCreatorWithPayload<(IPerson & { roleGroupIds?: string }) | undefined>;
